import React from 'react';
import './Dashboard.css';

const DiretoriaDashboard = () => {
  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Dashboard Diretoria</h1>
        <div className="date-filter">
          <select>
            <option>Últimos 7 dias</option>
            <option>Últimos 30 dias</option>
            <option>Este mês</option>
            <option>Este ano</option>
          </select>
        </div>
      </div>
      
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Processos Ativos</h3>
          <div className="stat-value">184</div>
          <div className="stat-trend up">+7% desde o último período</div>
        </div>
        
        <div className="stat-card">
          <h3>Novos Clientes</h3>
          <div className="stat-value">23</div>
          <div className="stat-trend up">+15% desde o último período</div>
        </div>
        
        <div className="stat-card">
          <h3>Processos Concluídos</h3>
          <div className="stat-value">45</div>
          <div className="stat-trend up">+12% desde o último período</div>
        </div>
        
        <div className="stat-card">
          <h3>Tempo Médio</h3>
          <div className="stat-value">38 dias</div>
          <div className="stat-trend down">-5% desde o último período</div>
        </div>
      </div>
      
      <div className="dashboard-row">
        <div className="dashboard-column">
          <div className="dashboard-card">
            <h3>Distribuição de Processos</h3>
            <div className="chart-placeholder">
              [Gráfico de pizza aqui]
            </div>
          </div>
        </div>
        
        <div className="dashboard-column">
          <div className="dashboard-card">
            <h3>Histórico de Processos</h3>
            <div className="chart-placeholder">
              [Gráfico de linha aqui]
            </div>
          </div>
        </div>
      </div>
      
      <div className="dashboard-card">
        <div className="card-header">
          <h3>Processos Prioritários</h3>
          <button>Ver Todos</button>
        </div>
        <table className="data-table">
          <thead>
            <tr>
              <th>Processo</th>
              <th>Cliente</th>
              <th>Responsável</th>
              <th>Prazo</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>PROC-2025-087</td>
              <td>Empresa ABC Ltda.</td>
              <td>Ana Silva</td>
              <td>15/05/2025</td>
              <td><span className="status-badge urgent">Urgente</span></td>
            </tr>
            <tr>
              <td>PROC-2025-092</td>
              <td>Tech Solutions S.A.</td>
              <td>Carlos Mendes</td>
              <td>18/05/2025</td>
              <td><span className="status-badge urgent">Urgente</span></td>
            </tr>
            <tr>
              <td>PROC-2025-104</td>
              <td>Construtora Horizonte</td>
              <td>Lucia Ferreira</td>
              <td>22/05/2025</td>
              <td><span className="status-badge warning">Atenção</span></td>
            </tr>
            <tr>
              <td>PROC-2025-108</td>
              <td>Supermercados Rede</td>
              <td>Paulo Santos</td>
              <td>25/05/2025</td>
              <td><span className="status-badge warning">Atenção</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DiretoriaDashboard;